import { useTestFormContext } from '@/app/features/reports/components/test-form/context';
import { TestStatus } from '@app.raytd.com/common/types/test-form';
import { TEST_STATUS_CONFIG } from '@/app/features/reports/utils/testStatus';
import { useCallback, useMemo } from 'react';
import { useFormContext } from 'react-hook-form';

import { useWatch } from 'react-hook-form';

const useTestStatus = () => {
  const { isReadyForNonDraftStatus, isRequiredFieldsFilled } = useTestFormContext();

  const isStatusDisabled = useCallback(
    (status: TestStatus): boolean => {
      const config = TEST_STATUS_CONFIG[status.toLowerCase()];
      // QA/Final require the record to be ready to leave Draft — validated
      // against that target status, not the record's current live status
      // (which would relax suite-required fields while still 'draft').
      return config.requiresValidation ? !isReadyForNonDraftStatus : !isRequiredFieldsFilled;
    },
    [isReadyForNonDraftStatus, isRequiredFieldsFilled]
  );

  const { control } = useFormContext();

  const currentStatus = useWatch({
    control,
    name: 'status',
  });

  const isFinalRestricted = useCallback(
    () => {
      return isStatusDisabled('published');
    },
    [isStatusDisabled]
  );

  const value = useMemo(() => {
    return {
      isStatusDisabled,
      currentStatus,
      isFinalRestricted,
    };
  }, [isStatusDisabled, currentStatus, isFinalRestricted]);

  return value;
};

export default useTestStatus;
